import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import {
  ChangeDetectorRef,
  DestroyRef,
  inject,
  PLATFORM_ID
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { EventService } from '~backoffice/app/~shared/services/event.service';
import { AuthFacade } from '~backoffice/app/~store/facades/auth.facade';
import { GlobalFacade } from '~backoffice/app/~store/facades/global.facade';
import { ConstantsService } from '~core/services/constants.service';
import { LoggerService } from '~core/services/logger.service';

export abstract class BaseAuthComponent {
  protected _destroyRef = inject(DestroyRef);
  protected _cdRef = inject(ChangeDetectorRef);
  protected _globalFacade = inject(GlobalFacade);
  protected _platformId = inject(PLATFORM_ID);
  protected _constantsService = inject(ConstantsService);
  protected _authFacade = inject(AuthFacade);
  protected _eventService = inject(EventService);
  protected _loggerService = inject(LoggerService);
  protected _fb = inject(FormBuilder);

  protected get _isPlatformBrowser(): boolean {
    return isPlatformBrowser(this._platformId);
  }

  protected get _isPlatformServer(): boolean {
    return isPlatformServer(this._platformId);
  }

  get environment(): ConstantsService['environment'] {
    return this._constantsService.environment;
  }

  get isSandboxEnvironment(): boolean {
    return this.environment.environmentVariant === 'sandbox';
  }
}
